import { displayTimeRangeTooltip, createPutData, getSlotUrl, handleSlotChange, getIsComUsingRequestSlots, handleNewSlot } from './summary_dws';
import { resizeSlotDOMElementsForUser, getTableStartDate, handleRawSlotChange, handleLinkedSlotsStats } from './summary_dws_table';
import { dateToTimeString, dateFromSecondsTimestamp, isMobileBrowser } from './common';
import { getSlotToDate } from "./slot_helpers";
import { config, handleClass } from './resizable_config';

export function getTimelineGridCellSize() {
  const timelineCellWidth = $(".user-row .row-right-fixed .grid-body-time-cell").first().outerWidth();
  const fallbackCellWidth = $(".user-row .grid-body-time-cell").first().outerWidth();
  const cellWidth = timelineCellWidth || fallbackCellWidth || 0;
  return cellWidth / 4;
}

export function calculateMarginLeftAfterResize(originalMarginLeft, positionLeft, rowWidth) {
  return ((positionLeft + originalMarginLeft) / rowWidth) * 100;
}

export function calculateMarginRightAfterResize(originalMarginRight, originalWidth, currentWidth, rowWidth) {
  return (((originalWidth - currentWidth) + originalMarginRight) / rowWidth) * 100;
}

export function calculateFromDiffMs(positionLeft, originalPositionLeft, resizeGridWidth) {
  return Math.round((positionLeft - originalPositionLeft) / resizeGridWidth * 900000); //15 minutes in milliseconds
}

export function calculateToDiffMs(width, originalWidth, positionLeft, originalPositionLeft, resizeGridWidth) {
  return Math.round((width - originalWidth + positionLeft - originalPositionLeft) / resizeGridWidth * 900000); //15 minutes in milliseconds
}

export function calculateFromAndToAfterResize(slot, resizeGridWidth, ui, axis) {
  let from = dateFromSecondsTimestamp(slot.FromUnix);
  const tableStartDate = getTableStartDate();
  if (from < tableStartDate) {
    from = tableStartDate;
  }
  let to = getSlotToDate(slot);

  //Resizing the left side of the slot
  if (axis === "w") {
    // fromDiffMilliseconds calculates the difference between origin start position of slot and target start position
    const fromDiffMilliseconds = calculateFromDiffMs(ui.position.left, ui.originalPosition.left, resizeGridWidth);
    if (fromDiffMilliseconds != 0) {
      from = new Date(from.valueOf() + fromDiffMilliseconds);
    }
  //Resizing the right side of the slot
  } else {
    // toDiffMilliseconds calculates the difference between origin end position of slot and target end position (using position and size of the cells)
    const toDiffMilliseconds = calculateToDiffMs(ui.size.width, ui.originalSize.width, ui.position.left, ui.originalPosition.left, resizeGridWidth);
    if (toDiffMilliseconds != 0) {
      to = new Date(to.valueOf() + toDiffMilliseconds);
    }
  }
  return {from, to};
}

function handleSlotResize(event, ui) {

  const slotEl = $(ui.element);
  const slotId = slotEl.data('id');
  let slot = SlotMap[slotId];
  const axis = slotEl.data("ui-resizable").axis;
  const resizeGridWidth = $( ".slots-cont.draggable" ).resizable( "option", "grid" )[0];
  const rowWidth = $(event.target).parent(".slots-overlay").width();
  const {from, to} = calculateFromAndToAfterResize(slot, resizeGridWidth, ui, axis);

  if (axis === "w") {
    const relativeMarginLeft = calculateMarginLeftAfterResize(parseInt(slotEl.data("original-margin-left")), ui.position.left, rowWidth);
    slotEl.css("margin-left", `${relativeMarginLeft}%`);
  } else {
    const relativeMarginRight = calculateMarginRightAfterResize(parseInt(slotEl.data("original-margin-right")), ui.originalSize.width, ui.size.width, rowWidth);
    slotEl.css("margin-right", `${relativeMarginRight}%`);
  }

  displayTimeRangeTooltip(slotEl, dateToTimeString(from), dateToTimeString(to));
}

function handleSlotResizeStart(event, ui) {
  const gridCellSize = getTimelineGridCellSize();
  //Grid is set dynamically in start because the grid size may have changed.
  $(".slots-cont.draggable").resizable("option","grid", [gridCellSize, 0]);
  const dragElement = $(event.target);
  dragElement.find('.sections-overlay').hide();
  if ($(ui.element).data("ui-resizable").axis === "w") {
    const originalMarginLeft = dragElement.css("margin-left").split("px")[0];
    dragElement.data('original-margin-left', originalMarginLeft);
  } else {
    const originalMarginRight = dragElement.css("margin-right").split("px")[0];
    dragElement.data('original-margin-right', originalMarginRight);
  }
}

export function removeResizeClasses(slotEl) {
  slotEl.find('.sections-overlay').show();
  slotEl.removeClass( "tooltip tooltip-bottom" );
}

function handleSlotResizeStop(ui) {
  const slotEl = $(ui.element);
  removeResizeClasses(slotEl);
  const slotId = slotEl.data('id');
  const slot = SlotMap[slotId];
  
  if (!slot) {
    return;
  }

  const axis = slotEl.data("ui-resizable").axis;
  
  // revert to original if user does not want to break out this repeat slot
  if (slot.RepeatKey && !confirm("このリピートシフトは解除され新規のシフトに変更されますが、よろしいですか？")) {
    slotEl.css("width", `${ui.originalSize.width}px`);

    if (axis === "w") {
      const originalMarginLeft = Number(slotEl.data("original-margin-left"));
      slotEl.css("margin-left", `${originalMarginLeft}px`);
      slotEl.css("left", `${ui.originalPosition.left}px`);
    } else {
      const originalMarginRight = Number(slotEl.data("original-margin-right"));
      slotEl.css("margin-right", `${originalMarginRight}px`);
    }
    
    return;
  }
  
  const resizeGridWidth = $(".slots-cont.draggable").resizable( "option", "grid" )[0];
  const {from, to} = calculateFromAndToAfterResize(slot, resizeGridWidth, ui, axis);

  putSlotAfterResize(slot, createPutData(slot, from, to, slot.UserID));
}

//TODO: Once we include request slots in re-render, then we can remove this. Note, this refresh check differed from the drag refresh check when the feature was made. If we can use the same check, then we should.
function shouldRefreshAfterPut(slot) {
  return getIsComUsingRequestSlots() && slot.RequestedSlotKey && !slot.RequestedSlot;
}

function putSlotAfterResize(slotBeforeEdit, data) {
  $.put(addURLSuffix(getSlotUrl(), slotBeforeEdit.ID), data, function(response) {

    if (!response.success) {
      alertModal.alert(errors.SLOT.UPDATE);
      return;
    }

    // Hard Refresh when Slot deleted have requested slot, will need to refactor in the future
    if (shouldRefreshAfterPut(response?.slot || response.addList[0])) {
      Refresh();
      return;
    }
    let slot;
    if (response.addList && response.addList.length > 0) {
      for (var i=0; i<response.addList.length; i++) {
        slot = response.addList[i];
        SlotMap[slot.ID] = slot;
        handleSlotChange(slot);
        $(`#slot-${slot.ID}`).remove();
        handleNewSlot(slot);
        reloadOnRepeat(slot);
      }

      // Stats requires special handling for linked slots.
      const isLinkedSlotsDrag = response.addList[0].LinkNext || response.addList[0].LinkPrev;
      if (isLinkedSlotsDrag) {
        handleLinkedSlotsStats(response.addList);
      } else {
        response.addList.forEach(s => handleRawSlotChange(s));
      }
    } else {
      slot = response.slot;
      SlotMap[slot.ID] = slot;
      handleSlotChange(slot);
      $(`#slot-${slot.ID}`).remove();
      handleRawSlotChange(slot);
      handleNewSlot(slot);
      reloadOnRepeat(slot);
    }
    resizeSlotDOMElementsForUser(slot.UserID);
  })
  .fail(function() {
    Refresh();
  });
}

// initResizableOnSlot is used to make a new slot element resizable.
export function initResizableOnSlot(slot) {
  const newElDOM = $(`#slot-${slot.ID}`);
  newElDOM.resizable(config);
  setSlotResizeHandleColor(slot)
  newElDOM.find(".ui-resizable-handle").click(function(e) {
    e.preventDefault();
    e.stopPropagation();
  });
}

function setSlotResizeHandleColor(rawSlot) {
  const handleColor = {
    backgroundColor: `#${rawSlot.Color}`,
    color: "#fff"
  }
  if (!rawSlot.Color) {
    handleColor.color = ""
  }

  $(`#slot-${rawSlot.ID} .ui-resizable-handle.ui-resizable-w`).css(handleColor);
  $(`#slot-${rawSlot.ID} .ui-resizable-handle.ui-resizable-e`).css(handleColor);
}

export function initResizable() {
  // Check if user is on mobile phone or not using browser detection
  if (isMobileBrowser()) {
    config.autoHide = false;
    config.classes["ui-resizable-handle"] = handleClass.mobile;
  }

  config.start = (event, ui) => handleSlotResizeStart(event, ui);
  config.stop = (_, ui) => handleSlotResizeStop(ui);
  config.resize = (event, ui) => handleSlotResize(event, ui);

  $(".slots-cont.draggable").each(function(index) {
    const rawSlot = SlotMap[$(this).data("id")]

    $(this).resizable(config);
    setSlotResizeHandleColor(rawSlot);
  });

  // Prevent click events from opening slot modal
  $(".ui-resizable-handle").click(function(e) {
    e.preventDefault();
    e.stopPropagation();
  });
}
